import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { Loader, WebCopy, WebHeading, Link } from 'components/shared';
import Icon from 'assets/icons';

import { gql } from 'apollo-boost';
import { useTranslation } from 'hooks';
import { useQuery } from '@apollo/react-hooks';

import { chromeInstallUrl, OrganizationTypes } from 'helpers/constants';
import { isExtensionInstalled, pingExtension, autoLoginExtension } from 'helpers/extension';
import { trackingOnboardingExtensionsView } from 'services/analytics';

import styles from './AddToChrome.module.scss';
import obstyles from '../../OnboardingScreen.module.scss';
import screenshot from 'assets/img/addToChrome.png';
interface AddToChromeData {
  me: {
    organization: Organization;
  };
}

const getOrganizationQuery = gql`
  query getIntegrations {
    me {
      organization {
        id
        name
        type
      }
    }
  }
`;

const AddToChrome = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [adding, setAdding] = React.useState(false);
  const [installed, setInstalled] = React.useState(isExtensionInstalled);

  const { error, data } = useQuery<AddToChromeData>(getOrganizationQuery, {
    fetchPolicy: 'cache-and-network',
  });

  useEffect(() => {
    trackingOnboardingExtensionsView();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (installed) {
      history.push('/onboarding/finish');
      return;
    }

    if (adding) {
      const interval = setInterval(() => {
        if (isExtensionInstalled) {
          setInstalled(true);
          autoLoginExtension();
        }

        // TODO do something here so this doesn't ping forever if no user action is taken
        pingExtension();
      }, 5000);
      return () => clearInterval(interval);
    }
  }, [adding, installed, history]);

  const handleAddToChrome = () => {
    setAdding(true);
  };

  if (data === undefined) return <Loader />;

  if (error) return <Loader color="Red" />;

  return (
    <div className={obstyles.contentLayout}>
      <div className={styles.contentWrapper}>
        <WebHeading className={styles.title} level={1}>
          {t('onboarding.add-to-chrome.heading')}
        </WebHeading>

        <WebCopy className={styles.copy}>
          {data.me.organization.type === OrganizationTypes.WORK &&
            t('onboarding.add-to-chrome.subheading-org', {
              organizationName: data.me.organization.name,
            })}
          {data.me.organization.type === OrganizationTypes.PERSONAL &&
            t('onboarding.add-to-chrome.subheading-personal', {
              organizationName: data.me.organization.name,
            })}
        </WebCopy>
      </div>

      <Link to={chromeInstallUrl} external={true} onClick={handleAddToChrome}>
        <img className={styles.screenshot} src={screenshot} alt="" />
      </Link>

      <Link
        to={chromeInstallUrl}
        external={true}
        type="Special"
        size="Small"
        onClick={handleAddToChrome}
        isLinkButton
      >
        <Icon.Plus className={styles.icon} />
        {t('onboarding.add-to-chrome.add-btn-label')}
      </Link>
    </div>
  );
};

export default AddToChrome;
